import { InjectionToken } from '@angular/core';
import { ComponentState } from '../interfaces/component-state.interface';
import { ComponentStateService } from '../services/component-state.service';

export const COMPONENT_STATE = new InjectionToken<ComponentState>('ComponentState', {
  providedIn: 'root',
  factory: () => new ComponentStateService()
});

